export default __webpack_public_path__ + "static/treatmentareas_fullbody-a2a2ce0dbb187c556e2745b093faffe6.webp";